var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"self-promotion-box"},[_c('ywhz-title-style-card',{attrs:{"title":_vm.$t('menu.menu4-5'),"subtitle":"Self Delivery"}}),_c('div',{staticClass:"layout-width"},[_c('third-self-promotion')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }